module.exports = __webpack_public_path__ + "img/DE01053.d6ca3545.png";